import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetChatMessage } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (chatid) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl2 + '/helpdesk-getchats';

    let formdata = new FormData();
    formdata.append("chat-id",chatid)
    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body: formdata
    };  

    const response = await doFetch(url,argument);
    
    if(response.ok){
        var data = fromJS({});
        data = fromJS(await response.json());
        var detail=data;
        data = fromJS(data.get('bubbles'));
        var chat = fromJS({});
        chat = chat.set(chatid, data);
        data = chat;
        dispatch({ type: GetChatMessage, chat: data,detail:detail });
    }
};